import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export type Role = 'admin' | 'user' | 'smm';

export interface AuthUser {
  id: string;
  email: string;
  role: Role;
  name: string | null;
  assignedTo: string | null;
}

interface AuthState {
  user: AuthUser | null;
  token: string | null;
  expiresAt: string | null;
  setAuth: (user: AuthUser, token: string, expiresAt: string) => void;
  logout: () => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      user: null,
      token: null,
      expiresAt: null,
      setAuth: (user, token, expiresAt) => set({ user, token, expiresAt }),
      logout: () => set({ user: null, token: null, expiresAt: null }),
    }),
    { name: 'heygen-auth' }
  )
);
